import { NoOpVisibilityService } from './visibility.service';
import { NoOpIntervalService } from './interval.service';
import { ElementRef, ChangeDetectorRef } from '@angular/core';

import { 
  Component, 
  OnChanges,
  Input,
  Output,
  SimpleChanges,
  EventEmitter,
  TemplateRef,
  ViewChild,
  NgZone,
  Inject,
  forwardRef,
} from '@angular/core';

import { isEqual, isNil, isEmpty, set } from 'lodash-es';
import { Subject } from 'rxjs';
import { takeUntil, mergeMap, shareReplay } from 'rxjs/operators';
import { BaseComponent } from './components/base.component';
import { SharedModule } from './shared.module';import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DatexFormControl, validateControlOnChange, validateFormOnControlChange } from './models/datex-form-control';
import { Styles, ControlContainerStyles } from './models/style';
import { FieldModel } from './models/field';
import { FieldsetModel } from './models/fieldset';
import { ToolModel } from './models/tool';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles,
  ValueControlModel
} from './models/control';
import { datCodeValidator } from './components/code-validator.directive';import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { PrintNode_ShellService } from './PrintNode.shell.service';
import { PrintNode_OperationService } from './PrintNode.operation.service';
import { PrintNode_DatasourceService } from './PrintNode.datasource.index';
import { PrintNode_FlowService } from './PrintNode.flow.index';
import { PrintNode_FrontendFlowService } from './PrintNode.frontend.flow.service';
import { PrintNode_ReportService } from './PrintNode.report.index';
import { PrintNode_LocalizationService } from './PrintNode.localization.service';
import { PrintNode_home_ComponentContextService } from './PrintNode.home.component.context.service';
import { Language } from './localization.service';
import { JobStatus, EAssignmentMode } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { $frontendTypes} from './PrintNode.frontend.types'
import { $frontendTypes as $types} from './PrintNode.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';
@Component({
  imports: [
    SharedModule,
  ],
  selector: 'PrintNode-home',
  templateUrl: './PrintNode.home.component.html'
})
export class PrintNode_homeComponent extends BaseComponent {


  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  //#endregion

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  //#region Variables
  //#endregion
  //#region Events
  
  //#endregion

  formGroup = new FormGroup({
  });

  get valid(): boolean {
    return this.formGroup.valid;
  }
  
  toolbar = {
  };

  fields = {
  };

  fieldsets = {
};


  $formGroupFieldValidationObservables = {
  }
  

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: PrintNode_ShellService,
    private $datasources: PrintNode_DatasourceService,
    private $flows: PrintNode_FlowService,
    private $frontendFlows: PrintNode_FrontendFlowService,
    private $reports: PrintNode_ReportService,
    private $localization: PrintNode_LocalizationService,
    private $operations: PrintNode_OperationService,
    private $context: PrintNode_home_ComponentContextService,
    elementRef: ElementRef,
    cdr: ChangeDetectorRef,
    private noOpVisibilityService: NoOpVisibilityService,
    private noOpIntervalService: NoOpIntervalService,) { 
    super(elementRef, cdr, noOpVisibilityService, noOpIntervalService);
    this.$subscribeFormControlValueChanges();
  }

  protected override $onInit(): void {
    this.$init();
  }
  

  private $unsubscribe$ = new Subject();
  protected override $onDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  initialized = false;

  async $init() {
    this.title = 'PrintNode';
  
    const $form = this;
    const $utils = this.$utils;



    this.initialized = true;
  }

  private $subscribeFormControlValueChanges() {
  }

  close() {
    this.$finish.emit();
  }

  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }
 
}
